// AA application field configuration  
// Note: Ship registration data with manual/bulk submission methods.
// Includes ship dataset, paid-up capital, AAIC code, and service scheme details.

export const AA_APPLICATION_FIELDS = [
    {
        sectionID: 'capital-details',
        sectionName: '',
        fieldList: [
            {
                id: 'company-paid-up-capital',
                label: 'Company\'s Paid Up Capital',
                type: 'number',
                span: 12,
                startAdornment: '$',
                rule: { required: true }
            },
        ]
    },
    {
        sectionID: 'registered-ship-information',
        sectionName: 'Singapore Registered Ship Information',
        fieldList: [
            {
                id: 'submission-method',
                label: 'Submission Method',
                type: 'radio',
                options: [
                    { optID: 'SM2', optLabel: 'Manual Entry' },
                    { optID: 'SM1', optLabel: 'Bulk Upload' }
                ],
                rule: { required: true }
            },
            {
                id: 'list-registered-ships',
                label: 'List of Singapore Registered Ships',
                type: 'shipDataSet',
                options: [],
                span: 12,
                rule: {
                    required: true,
                    // TODO: Commented out minimum 10 rows validation - to be re-enabled later
                    // // Minimum 10 rows required for submission (both manual entry and bulk upload)
                    // customValidate: ({ getValues }: any) => {
                    //     const rows = getValues('registered-ship-information-list-registered-ships') || getValues('list-registered-ships');
                    //     if (!Array.isArray(rows) || rows.length === 0) {
                    //         return 'Please provide at least 10 registered ship entries';
                    //     }
                    //     if (rows.length < 10) {
                    //         return `Minimum 10 ship entries required. Currently have ${rows.length} ${rows.length === 1 ? 'entry' : 'entries'}`;
                    //     }
                    //     return true;
                    // }
                }
            },
            {
                id: 'aaic-code',
                label: 'AAIC Code',
                type: 'text',
                span: 12,
                labelNote: 'This value will be populated for all entries in the AAIC Code column of the \'List of Singapore Registered Ships\' table above upon submission'
            },
            {
                id: 'scheme-of-service',
                label: 'Scheme of service including the terms and conditions and the fees for the AA service',
                type: 'longText',
                span: 12,
                rule: { required: true }
            }
        ]
    }
];
